import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography, useMediaQuery, Card, CardContent, CardActions, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider } from "@mui/material"
import Header from './Header'
import FlexBetween from './FlexBetween'
import { UserAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { motion } from "framer-motion";
import Grid from '@mui/material/Unstable_Grid2';
import TokenContext from '../context/TokenContext'
import { encuestasDocente, encuestasDocenteCompletada } from '../Redux/evaluaciones'
import { COLUMNSENCUESTAS } from '../columnas/columnasEvaluacion'
import TablaEvaluaciones from './tablas/TablaEvaluaciones'
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import ModalEncuesta from './modales/ModalEncuesta'

const EncuestaDocente = () => {
    const dispatch = useDispatch()
    const token = useContext(TokenContext)
    const theme = useTheme()
    const { empleado } = UserAuth() //empleado contiene el usuarioPortalRh y empleadoid, esos dos valores son necesarios para las consultas a los fetch.

    const [idEvaluacion, setIdEvaluacion] = React.useState('')
    const [openModal, setOpenModal] = React.useState(false);
    const [evaluacionPendiente, setEvaluacionPendiente] = React.useState([])

    const [loading, setLoading] = React.useState(false)
    const [loading2, setLoading2] = React.useState(false)
    const [encuestas, setEncuestas] = React.useState([])
    const [encuestasCompletas, setEncuestasCompletas] = React.useState([])

    const [columnaEncuesta, setColumnaEncuesta] = React.useState(COLUMNSENCUESTAS)
    const encuestasSelector = useSelector(store => store.evaluaciones.encuestaDocente)
    const loadingSelector = useSelector(store => store.evaluaciones.loadingEncuesta)
    const encuestasCompletasSelector = useSelector(store => store.evaluaciones.encuestaDocenteCompleta)
    const loadingCompletaSelector = useSelector(store => store.evaluaciones.loadingEncuestaCompleta)
    const resultadoModificacion = useSelector(store => store.evaluaciones.modificacionEvaluacion)

    React.useEffect(() => {
        if (token) {
            dispatch(encuestasDocente(token, empleado.empleadoid))
            dispatch(encuestasDocenteCompletada(token, empleado.empleadoid))
        }
    }, [token, empleado])

    React.useEffect(() => {
        setLoading(loadingSelector)
        setLoading2(loadingCompletaSelector)
    }, [loadingSelector, loadingCompletaSelector])

    React.useEffect(() => {
        if (encuestasSelector.length > 0) {
            var array = []
            encuestasSelector.forEach(element => {
                var objeto = {
                    id: element.new_evaluacionid,
                    new_evaluado: element["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluado_value: element._new_evaluado_value,
                    _new_evaluador_value: element._new_evaluador_value,
                    new_evaluador: element["_new_evaluador_value@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluado: element["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
                    new_tipodeevaluacion: element["new_tipodeevaluacion@OData.Community.Display.V1.FormattedValue"],
                    _new_periodo_value: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    new_fechadevencimiento: element["new_fechadevencimiento@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluador_value: element._new_evaluador_value,
                    new_evaluador: element["_new_evaluador_value@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    _new_divisin_value: element._new_divisin_value,
                    new_divisin: element["_new_divisin_value@OData.Community.Display.V1.FormattedValue"],
                    _new_modalidad_value: element._new_modalidad_value,
                    new_modalidad: element["_new_modalidad_value@OData.Community.Display.V1.FormattedValue"],
                    new_seccion: element.new_seccion,
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    createdon: element["createdon@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setEncuestas(array)
        }
    }, [encuestasSelector])

    React.useEffect(() => {
        if (encuestasCompletasSelector.length > 0) {
            var array = []
            encuestasCompletasSelector.forEach(element => {
                var objeto = {
                    id: element.new_evaluacionid,
                    new_evaluado: element["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluado_value: element._new_evaluado_value,
                    _new_evaluador_value: element._new_evaluador_value,
                    new_evaluador: element["_new_evaluador_value@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluado: element["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
                    new_tipodeevaluacion: element["new_tipodeevaluacion@OData.Community.Display.V1.FormattedValue"],
                    _new_periodo_value: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    new_fechadevencimiento: element["new_fechadevencimiento@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluador_value: element._new_evaluador_value,
                    new_evaluador: element["_new_evaluador_value@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    _new_divisin_value: element._new_divisin_value,
                    new_divisin: element["_new_divisin_value@OData.Community.Display.V1.FormattedValue"],
                    _new_modalidad_value: element._new_modalidad_value,
                    new_modalidad: element["_new_modalidad_value@OData.Community.Display.V1.FormattedValue"],
                    new_seccion: element.new_seccion,
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    createdon: element["createdon@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setEncuestasCompletas(array)
        }
    }, [encuestasCompletasSelector])

    React.useEffect(() => {
        if (resultadoModificacion !== undefined) {
            if (resultadoModificacion !== '' && resultadoModificacion == "EXITO") {
                dispatch(encuestasDocente(token))
                dispatch(encuestasDocenteCompletada(token))
                setTimeout(() => {
                    handleCloseModal()
                }, 1000)
            }
        }
    }, [resultadoModificacion])

    //======|| handlers del modal evaluaciones pendientes ||====== //
    const handleCloseModal = () => {
        setOpenModal(false)
        setEvaluacionPendiente('')
    };

    const handleOpenModalPendientes = (id) => {
        setOpenModal(true);
        setIdEvaluacion(id)
        setEvaluacionPendiente(encuestas.filter((item) => item.id == id));
        // dispatch(evaluacionPorId(token, id))
    };
    //======================================================= //

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >
                <Header title={"Encuestas Docente"} subtitle="" />

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Mis encuestas pendientes de completar
                            </Typography>
                        </Box>
                        {
                            loading ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                        py: 2
                                    }}>
                                    <CircularProgress color="secondary" />
                                </Box>
                            )
                                : encuestas.length > 0 ? (
                                    <TablaEvaluaciones columnas={columnaEncuesta} lineas={encuestas} handleOpen={handleOpenModalPendientes} acciones={true} />
                                ) :
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        Aún no tienes registros de <strong>Encuestas</strong>.
                                    </Alert>
                        }
                    </Grid>

                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Mis encuestas completadas
                            </Typography>
                        </Box>
                        {
                            loading2 ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                        py: 2
                                    }}>
                                    <CircularProgress color="secondary" />
                                </Box>
                            )
                                : encuestasCompletas.length > 0 ? (
                                    <TablaEvaluaciones columnas={columnaEncuesta} lineas={encuestasCompletas} />
                                ) :
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        Aún no tienes registros de <strong>Encuestas completadas</strong>.
                                    </Alert>
                        }
                    </Grid>
                </Grid>
            </Box>
            <ModalEncuesta open={openModal} handleClose={handleCloseModal} evaluacionPendiente={evaluacionPendiente[0]} idEvaluacion={idEvaluacion} />
        </motion.div>
    )
}

export default EncuestaDocente